// A PO sent waits on the mail provider ('sending') until the provider confirms it went. The office's
// list and open PO check back until it settles, so the open PO shows Sent and its Receive button
// without being closed and opened again (QA-861).

export const SENDING_CHECK_MS = 3000;

/**
 * Asks `settled` every few seconds, one ask at a time, until it says yes; then calls `then` once and
 * stops. A failed ask is tried again at the next check. Returns the stop for an effect's cleanup.
 */
export function checkUntilSettled(
  settled: () => Promise<boolean>,
  then: () => void,
  every = SENDING_CHECK_MS,
): () => void {
  let stopped = false;
  let timer: ReturnType<typeof setTimeout> | undefined;
  const tick = () => {
    timer = setTimeout(() => {
      settled().then(
        (yes) => {
          if (stopped) return;
          if (yes) {
            stopped = true;
            then();
          } else tick();
        },
        () => {
          if (!stopped) tick();
        },
      );
    }, every);
  };
  tick();
  return () => {
    stopped = true;
    if (timer !== undefined) clearTimeout(timer);
  };
}
